import React, { PureComponent, ComponentType } from 'react';

/**
 * Only generates the props once, on init, for each wrapped component
 * Particularly useful for generating instance-specific selectors with reselect
 */
export default function WithPropsOnce<OwnProps extends object, Injected extends object>(
    propsGenerator: (props: OwnProps) => Injected | null,
) {
    return (WrappedComponent: ComponentType<OwnProps & Injected>) =>
        class WithPropsOnce extends PureComponent<OwnProps, Injected | null> {
            constructor(props: OwnProps) {
                super(props);
                this.state = propsGenerator(props) || null;
            }

            render() {
                // HOC prop-merging is not expressible to the JSX checker without widening
                // the wrapped component; the runtime contract is the OwnProps/Injected generics.
                const Wrapped = WrappedComponent as unknown as ComponentType<Record<string, unknown>>;
                const injected = (this.state ?? {}) as Record<string, unknown>;
                return <Wrapped {...(this.props as Record<string, unknown>)} {...injected} />;
            }
        };
}
